"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var DateWidget = function (_a) {
    var dateProps = _a.dateProps;
    var _b = (0, react_1.useState)(new Date()), currentDate = _b[0], setDate = _b[1];
    // keep updating clock time
    (0, react_1.useEffect)(function () {
        var timeTimer = setInterval(function () {
            setDate(new Date());
        }, 1000);
        return function () {
            if (timeTimer) {
                clearInterval(timeTimer);
            }
        };
    }, []);
    // update moment localization to given language
    (0, react_1.useEffect)(function () {
        moment_1.default.locale(dateProps.language);
    }, [dateProps.language]);
    var styles = dateProps.styles, format = dateProps.format;
    return react_1.default.createElement("div", { style: styles }, (0, moment_1.default)(currentDate).format(format));
};
exports.default = DateWidget;
//# sourceMappingURL=DateWidget.js.map